import { useState } from 'react';
import './styles/navbar.css';
import PropTypes from 'prop-types';

import CV from '../assets/Arthur_Bordet_CV_2023.pdf'
/**
 * Component representing the navigation bar of the application.
 * @param {Function} actionHandler - Callback function to handle an action.
 * @returns {JSX.Element} The Navbar component.
 */
export default function Navbar({ actionHandler, fadeOut }) {
    const [isOpen, toggleOpen] = useState(false)
    return (
        <div className={`navbar${fadeOut ? " fade-out" : ""}${isOpen ? " open" : ""}`}>
            <div className="logo cursor-detect-hover">
                <span className='cursor-hoverable' onClick={() => {
                    actionHandler("/")
                }}>Arthur Bordet</span></div>
            <div className="socials">@VoidSplit</div>
            <div className="links flx-row">
                <div onClick={() => {
                    actionHandler("/")
                }} className="link cursor-detect-hover">
                    <div className='cursor-hoverable' href="/">Accueil</div>
                </div>
                <div onClick={() => {
                    actionHandler("/projects")
                }} className="link cursor-detect-hover">
                    <div className='cursor-hoverable' href="/">Projets</div>
                </div>
                <a
                    href={CV}
                    download="Arthur_Bordet_CV_2023"
                    target="_blank"
                    rel="noreferrer"
                    className="link cursor-detect-hover">
                    <div className='cursor-hoverable' href="/">CV</div>
                </a>
                <div onClick={(e) => {
                    window.location.href = "mailto:arthur-bordet@gmail.com";
                    e.preventDefault();
                }} className="link cursor-detect-hover">
                    <div className='cursor-hoverable' href="/">Contact</div>
                </div>
            </div>
            <div className="responsive-icon" onClick={() => {
                toggleOpen(!isOpen)
            }}>
                <span></span><span></span>
            </div>
        </div>
    );
}

Navbar.propTypes = {
    actionHandler: PropTypes.func.isRequired,
};